module.exports = __webpack_public_path__ + "static/confetti-3e666af3c74ab7e8fd1c8a2f5d9b6efd.mp4";